<template>
	<div class="pay_vcode">
		<div class="fast-card">
			<div class="fast-subtitle">套餐信息</div>
			<ul class="fast-cont">
				<li><span class="fast-label">产品名称</span><span>{{ order_title }}</span></li>
				<li><span class="fast-label">订单金额</span><span class="yellow">￥ {{ order_price }}元</span></li>
				<li><span class="fast-label">服务时长</span><span>{{ service_period }}{{ granularityDesc }}</span></li>
			</ul>
		</div>
		<div class="fast-card">
			<div class="fast-subtitle">支付方式</div>
			<div class="fast-checked">
				<img src="/static/img/bank/weixin_pay.png" class="wx">
				<span>{{ vendor_title }}</span>
				<img src="/static/img/payicon.png" class="pull-right checked">
			</div>
			<div class="fast-checked morn-way">
				<div class="more-way" @click="mornPayWay">
					<span class="more-pay">更多支付方式</span>
					<span class="morn-arrow"><i class="ic-arrow"/></span>
				</div>
			</div>
		</div>

		<div class="action">
			<button class="submit" type="button" @click="payOrder">立即支付</button>
		</div>
	</div>	
</template>

<script>
import { Button } from 'mint-ui'
import wx from 'weixin-js-sdk'

export default {
	name: 'OneKeyPayment',
	data: () => ({
		'order_no': 'abcd',
		'order_title': '',
		'order_price': 0.00,
		'service_period': 0,
		'route_code': '',
		'route_name': '',
		'vendor_title': '',
		'timer': null,
		'counting': 0,
		'granularityDesc': '个月',
		'granularity': 1,
	}),
	computed: {
	},
	created () {
		this.loadDetail()
	},
	components: {
		'mt-button': Button
	},
	mounted: function () {
		this.setPageTitle('自助支付')
	},
	methods: {
		loadDetail () {
			this.loading('正在读取信息')
			let self = this
			this.order_no = this.$route.params.id
			this.createOneKeyOrder(this.order_no, rs => {
				this.$store.dispatch('setOrder', {'order': rs})
				if (rs.code === 0) {
					self.order_title = rs.product_pkg_title
					self.order_price = rs.pay_price
					self.service_period = rs.service_period
					self.granularity = rs.granularity
					if (parseInt(self.granularity, 10) === 2 ) {
						self.granularityDesc = '天'
					}
				} else {
					self.toast(rs.message)
				}

				self.getOneKeyPayWay(rs.order_no, res => {
					if (res.code === 0) {
						var payway = res.payWayList[0]
						self.route_code = payway.routeCode
						self.route_name = payway.name
						self.vendor_title = payway.title
					} else {
						self.toast(res.message)
					}
				})
			})
		},
		checkPayStatus (rolling) {
			let url = '/api/payments/status/' + this.payTraceNo
			this.$http.get(url).then(response => {
				// console.log(response)
				var rs = response.body
				if (rs.code === 0) {
					if (rs.data.status === 1) {
						this.$store.dispatch('setOrder', {'order': rs.data.order})
						if (rs.data.full_pay === true) {
							// window.location.href = '#/orders/verify/' + this.$route.params.id
							window.location.href = '/'
						}
					} else if (rs.data.status === 2) {
						this.toast('支付失败，请重新支付')
					} else {
						if (rolling) {
							this.rollingPayStatus()
						} else {
							this.toast('支付超时')
							window.location.reload()
						}
					}
				} else {
					this.handleHttpError(response)
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		},
		rollingPayStatus () {
			if (this.timer) {
				clearTimeout(this.timer)
				this.timer = null
			}
			if (this.counting >= 300) {
				// 5分钟
				this.toast('支付超时')
				window.location.reload()
			} else {
				let self = this
				this.timer = setTimeout(function () {
					self.checkPayStatus(true)
				}, 2000)
				this.counting += 2
			}
		},
		configWechatPay (data) {
			wx.config({
				debug: false,
				appId: data.jsapi.appId,
				timestamp: data.jsapi.timestamp,
				nonceStr: data.jsapi.nonceStr,
				signature: data.jsapi.signature,
				jsApiList: ['checkJsApi', 'chooseWXPay']
			})
			let self = this
			this.payTraceNo = data.traceNo
			wx.ready(function () {
				wx.checkJsApi({
					jsApiList: ['chooseWXPay'] // 需要检测的JS接口列表，所有JS接口列表见附录2,
				})
				wx.chooseWXPay({
					timestamp: data.timestamp,
					nonceStr: data.nonceStr,
					package: data.packageName,
					signType: data.signType,
					paySign: data.sign,
					success: function (res) {
					},
					cancel: function (res) {
						console.log(res)
					}
				})
				self.rollingPayStatus()
			})
			wx.error(function (res) {
				console.log(res)
				self.toast(res)
			})
		},
		toMpLogin () {
			let url = '/api/mp?order_no=' + this.$route.params.id
			window.location.href = url
		},
		payOrder () {
			this.loading('正在提交...')
			let url = '/api/payment'
			let params = {
				amount: this.order_price,
				route_code: this.route_code,
				route_name: this.route_name,
				vendor_title: this.vendor_title,
				order_no: this.order_no
			}
			console.log('PureDebugParams:', params)
			this.$http.post(url, params).then(response => {
				console.log(response)
				var rs = response.body
				if (rs.code === 0) {
					this.loadingHide()
					if (rs.data.code === 'to_mp_login') {
						this.toMpLogin()
					} else {
						this.configWechatPay(rs.data)
					}
				} else {
					this.loadingHide()
					this.handleHttpError(response)
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		},
		mornPayWay() {
			this.$router.push({ name: 'Payways', params: { id: this.order_no } })
		}
	}
}
</script>

<style scoped>
.pay_fast{font-size: 14px; max-width: 500px; margin: 10px auto 0;}
.fast-card{ background: #fff; margin-top: 10px;}
.fast-subtitle{ height: 40px; line-height: 40px; font-weight: 700; border-bottom: 1px solid #e2e2e2; padding: 0 15px;}
.fast-cont{	padding: 0 15px; padding: 9px 15px; line-height: 1;}
.fast-cont li{ padding: 6px 0;}
.fast-label{ color: #666; margin-right: 20px; padding: 6px 0;}
.yellow{ color: #ff8a05;}
.fast-checked{height: 44px; line-height: 44px; padding: 0 15px;}
.fast-checked .wx{width: 25px; margin-right: 6px; vertical-align: -8px;}
.fast-checked .checked{ width: 20px; margin-top: 12px;}
.action{ text-align: center; position: fixed; bottom: 32px; width: 100%}
.submit{ width:180px; height: 44px; font-size: 15px; text-align: center; color: #fff; background: #439aff; border: none; outline: none; -webkit-appearance: none; border-radius: 2px; cursor: pointer;}
.submit:active{ background: #2b8cfa; }
.more-pay{
	text-align: center;
}
.morn-arrow{
	float: right;
	margin-right: 7px;
}
.more-way{
	border-top: 1px solid #f2f2f2;
	line-height:44px;
}

.fast-checked.morn-way{
	height: 45px;
	line-height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/views/onekey/PayOnline.vue